// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.down_btn_area > label[data-v-12d9cdea] {margin-left: 0px;}\n", ""]);
// Exports
module.exports = exports;
